import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pistatus-drop-down',
  templateUrl: './pistatus-drop-down.component.html',
  styleUrls: ['./pistatus-drop-down.component.css'],
})
export class PistatusDropDownComponent {
  @Input() currentStatus: string = '';
  @Input() inputList: any = [];
  @Input() productId: string = '';
  @Input() type: string = '';
  selectedStatus: string = '';
  @Output() statusSelected: EventEmitter<any> = new EventEmitter<any>();

  getStatus() {
    this.statusSelected.emit({
      selectedPiStatus: this.currentStatus,
      type: this.type,
      productId: this.productId,
    });
  }
}
